import {useQuery, UseQueryReturnType} from "@tanstack/vue-query";
import {get} from "@/api/base";
import {HttpStatusCode} from "axios";
import moment from "moment/moment";
import {MaybeRef} from "@vueuse/core";
import {computed, unref} from "vue";
import {JobPredictionResponse} from "@/models/job-prediction";
import {convertToCamelCase} from "@/models/utils/casing";

export function useGetJobAutomationQuery(jobNumber: MaybeRef<number>) {
  const computedJobNumber = computed(() => unref(jobNumber)).value
  
  return useQuery({
    queryKey: ['job-automation', computedJobNumber],
    queryFn: async () => {

      const response = await get<JobPredictionResponse>(
        `/api/jobs/${computedJobNumber}/automation/details`,
        {headers: {"Api-Version": "2025-06-01"}}
      )
      if (response.status === HttpStatusCode.NoContent) {
        return null;
      }
      return convertToCamelCase(response.data);
    },
    staleTime: moment.duration(10, 'minutes').asMilliseconds(),
  })
  
}
